

import CountBanner from "@/components/001-Main-Home/CountBanner/CountBanner";
import EportalExp from "@/components/001-Main-Home/ExperienceEportal/EportalExp";
import HeroImageSection from "@/components/001-Main-Home/HeroImageSection/HeroImageSection";
import SessionForm from "@/components/001-Main-Home/Sessionform/Sessionform";
import Testimonial from "@/components/001-Main-Home/Testimonialone/Testimonial";
import VideoScroller from "@/components/001-Main-Home/VideosBanner/VideosBanner";
import UnsubscribeModal from "@/components/Modal/UnsubscribeModal";
import { useRouter } from "next/router";
import { useState, useEffect } from "react";

function MainHome() {
  const router = useRouter();
  const [showUnsubscribeModal, setShowUnsubscribeModal] = useState(false);
  const [unsubscribeEmail, setUnsubscribeEmail] = useState("");

  useEffect(() => {
    const handleUnsubscribe = () => {
      const { unsubscribe } = router.query;

      if (unsubscribe && router.isReady) {
        setUnsubscribeEmail(unsubscribe);
        setShowUnsubscribeModal(true);

        router.replace("/", undefined, { shallow: true });
      }
    };

    handleUnsubscribe();
  }, [router.query, router.isReady]);

  return (
    <div className="min-vh-100 w-100 flex items-center justify-center overflow-x-hidden">
      <div className="w-full overflow-x-hidden">
        <HeroImageSection />
        <CountBanner />
        <SessionForm />
        <VideoScroller />
        <EportalExp />
        <Testimonial />
      </div>

      {showUnsubscribeModal && (
        <UnsubscribeModal
          email={unsubscribeEmail}
          onClose={() => {
            setShowUnsubscribeModal(false);
            setUnsubscribeEmail("");
          }}
        />
      )}
    </div>
  );
}

export default MainHome;
